module.exports = "<div>\r\n    <p>\r\n      {{data.message}}\r\n    </p>\r\n  </div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/create-corporate-user/dialog/dialog.component.html
// module id = ../../../../../src/app/main/content/create-corporate-user/dialog/dialog.component.html
// module chunks = main